import '../../scss/tagbook/index.scss';
import * as React from 'react';
import { render } from 'react-dom';
import { Index } from './components';
document.addEventListener('DOMContentLoaded', function () {
    initReactRoot();
});
var initReactRoot = function () {
    var root = document.querySelector('#tagbook--directory');
    if (!root) {
        return;
    }
    render(React.createElement(Index, null), root);
};
